import Store from 'redux/store';
import { ACTIONS_TYPES } from 'redux/helper';
import { getCurrentContract } from './contract';

const mergeGroupPrivileges = (groups) => (
  groups.reduce((acc, group) => {
    const { properties = {} } = group;
    Object.keys(properties).forEach((key) => {
      acc[key] = acc[key] || properties[key];
    });
    return acc;
  }, {})
);

const checkPrivilege = (privilege) => {
  const { [ACTIONS_TYPES.GROUP.GET_USER_GROUPS]: groups = [] } = Store.getState();
  const privileges = mergeGroupPrivileges(groups);
  return privileges[privilege];
};

export const userHasPrivilege = (privilege) => checkPrivilege(privilege);

export const userIsAdmin = () => {
  const { [ACTIONS_TYPES.USER.GET_CURRENT_USER]: currentUser = {} } = Store.getState();
  const { properties = {} } = currentUser;
  return !!properties.administrator;
};

export const userIsContractOwner = () => {
  const {
    [ACTIONS_TYPES.USER.GET_CURRENT_USER]: currentUser = {},
    [ACTIONS_TYPES.CONTRACT.GET_ALL]: contracts = [],
  } = Store.getState();

  const contract = getCurrentContract(contracts);

  const { properties: contractProps = {} } = contract || {};
  const { properties: userProps = {} } = currentUser || {};

  return contractProps.owner && contractProps.owner === userProps.email;
};
